import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'コミュニティ',
  
  // model
  communityModel: [],

  // 検索
  filters: {
    searchCommunityName: null,
    searchTenantName: null,
    searchStatus: '',
  }
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {communityParams, tenantParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'community',
          'tenant'
        ],
        [
          'v1CommunityListGet',
          'v1TenantListGet'
        ],
        [
          communityParams,
          tenantParams
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setCommunityModel', res[0].data.communities)
            console.log('communityModel', state.communityModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * コミュニティ一覧を読出し
   */
  loadCommunityList ({commit}, {communityParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['community'],
        ['v1CommunityListGet'],
        [communityParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setCommunityModel', res[0].data.communities)
            console.log('communityModel', state.communityModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  reset({commit}) {
    commit('resetState')
  }
}

const mutations = {
  // model
  setCommunityModel (state, data) {
    Vue.set(state, 'communityModel', data)
  },

  setInputFilter (state, {key, value}) {
    Vue.set(state.filters, key, value)
  },

  resetState (state) {
    Vue.set(state, 'communityModel', [])

    state.filters.searchCommunityName = null
    state.filters.searchTenantName = null
    state.filters.searchStatus = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
